import { CSSProperties } from "react";

import type { Nullable, ObjectType } from "models-webgl2";

export const applyCSSToNode = (
  node: Nullable<HTMLElement>,
  stylesToApply: CSSProperties | ObjectType<string | number>,
) => {
  if (!node) return;

  // Note: setting styles as 'style[key as any]' is  faster than 'setProperty'
  Object.entries(stylesToApply).forEach(([key, value]) => {
    if (key.startsWith("--")) {
      node.style.setProperty(key, value);
    } else {
      node.style[key as any] = value;
    }
  });
};
